
<section
  v-if="isShowTitle()"
  :id="$style.Header"
  ref="Header"
  :class="$style.Header"
>
  <button :class="$style['back-wrap']" @click="back">
    <Icon :class="$style['ico-back']" type="left" />
  </button>
  <span>
    {{ title }}
  </span>
</section>
